import type { Column, ColumnPin } from "@common/types/views/views";
import type { DataGridLeafColumnInfo } from "../columns/columnLayout";
import type { DataGridPin } from "../columns/types";

/** A DataGrid pin as saved views and the column menus name it. */
export const VIEW_PIN: Record<DataGridPin, ColumnPin> = {
    start: "left",
    end: "right",
};

export const getValueIds = (leaves: readonly DataGridLeafColumnInfo[]) =>
    leaves.filter((leaf) => !leaf.isDisplay).map((leaf) => leaf.id);

/** `Column["options"]` with ViewTable's legacy `variant` mirror. */
export type SavedColumnOptions = NonNullable<Column["options"]> & {
    variant?: string;
};
